import { Grid, styled } from '@mui/material'

export const StyledGridItem = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}))
